import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={352}
    height={219}
    viewBox="0 0 352 219"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_99_676"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={352}
      height={219}
    >
      <path d="M351.119 0H0.881836V218.898H351.119V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_99_676)">
      <mask
        id="mask1_99_676"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={30}
        y={37}
        width={296}
        height={183}
      >
        <path
          d="M325.65 37.4453H30.3037V219.659H325.65V37.4453Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_99_676)">
        <path
          d="M262.603 77.8672C262.603 77.8672 254.373 13.4626 205.812 59.7666C143.56 119.122 101.715 1.15229 55.5342 49.3062C30.3049 75.6124 96.9729 134.446 52.4481 165.408C7.92336 196.369 44.3081 219.549 44.3081 219.549H297.131C297.131 219.549 323.304 221.439 325.285 188.321C327.263 155.202 296.839 154.801 315.721 113.357C334.604 71.9128 268.537 104.246 262.603 77.8672Z"
          fill="#D5E8E8"
          fillOpacity={0.3}
        />
        <g opacity={0.3}>
          <path
            d="M291.882 149.758H303.644"
            stroke="#9CACCE"
            strokeWidth={1.31339}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g opacity={0.3}>
          <path
            d="M292.754 172.783H289.124V172.553C289.124 170.669 287.608 169.153 285.724 169.153C284.851 169.153 284.07 169.474 283.427 170.026V169.98C282.508 167.177 279.889 165.109 276.719 165.109C272.859 165.109 269.689 168.234 269.689 172.139C269.689 172.507 269.734 172.874 269.78 173.242L269.689 173.334H267.805"
            stroke="#9CACCE"
            strokeWidth={1.31339}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M43.9873 219.156H284.899"
          stroke="#9CACCE"
          strokeWidth={1.75118}
          strokeMiterlimit={10}
        />
        <path
          d="M293.335 219.156H323.109"
          stroke="#9CACCE"
          strokeWidth={1.75118}
          strokeMiterlimit={10}
        />
      </g>
      <mask
        id="mask2_99_676"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={267}
        y={145}
        width={89}
        height={74}
      >
        <path
          d="M273.556 213.628C273.556 216.047 289.964 218.009 310.205 218.009C330.446 218.009 346.854 216.047 346.854 213.628L355.509 145.137L267.999 151.548L273.556 213.628Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_99_676)">
        <path
          d="M346.853 213.631C346.853 216.051 330.445 218.012 310.204 218.012C289.963 218.012 273.555 216.051 273.555 213.631C273.555 211.212 289.963 209.25 310.204 209.25C330.445 209.25 346.853 211.212 346.853 213.631Z"
          fill="#ECF4F4"
        />
      </g>
      <mask
        id="mask3_99_676"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={267}
        y={145}
        width={89}
        height={74}
      >
        <path
          d="M273.556 213.628C273.556 216.047 289.964 218.009 310.205 218.009C330.446 218.009 346.854 216.047 346.854 213.628L355.509 145.137L267.999 151.548L273.556 213.628Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_99_676)">
        <path
          d="M302.53 202.277C309.554 216.132 303 223.814 307.105 225.276C307.318 225.351 307.515 225.401 307.711 225.42C311.09 225.789 311.757 217.946 324.659 210.615C332.818 205.971 348.153 197.809 346.229 191.13C344.578 185.415 333.278 194.185 330.437 186.313C328.369 180.591 341.797 182.068 340.995 176.387C340.108 170.095 330.29 175.877 330.532 169.995C330.78 164.121 338.672 157.775 334.063 155.224C333.991 155.183 333.917 155.15 333.85 155.118C329.352 152.901 325.844 159.898 323.77 164.597C321.662 169.369 321.34 170.954 319.927 170.188C318.513 169.423 315.658 162.108 311.592 164.986C307.524 167.872 314.822 178.876 312.304 185.054C309.783 191.238 305.703 178.86 301.852 184.188C299.643 187.256 299.035 195.398 302.53 202.277Z"
          fill="#E3EDED"
        />
        <path
          d="M305.185 188.907L314.07 202.245L320.251 185.847L320.233 185.854L315.693 173.549L320.776 184.455L327.995 165.305L324.316 176.72L332.447 176.404L323.97 177.794L318.356 195.21L335.636 195.31L318.028 196.227L310.879 218.137L308.833 217.422L313.618 203.441L305.185 188.907Z"
          fill="white"
        />
        <path
          d="M289.724 169.431C289.724 169.431 277.03 163.315 280.759 159.987C284.487 156.66 289.833 169.418 289.833 169.418"
          fill="#B5C9C9"
        />
        <path
          d="M295.591 174.095C295.591 174.095 281.925 177.524 282.658 172.581C283.392 167.638 295.667 174.016 295.667 174.016"
          fill="#B5C9C9"
        />
        <path
          d="M300.477 181.428C300.477 181.428 286.866 185.072 287.522 180.118C288.178 175.164 300.551 181.348 300.551 181.348"
          fill="#B5C9C9"
        />
        <path
          d="M304.095 191.263C304.095 191.263 290.479 194.888 291.142 189.934C291.804 184.981 304.169 191.183 304.169 191.183"
          fill="#B5C9C9"
        />
        <path
          d="M306.08 200.597C306.08 200.597 292.168 202.834 293.326 197.973C294.484 193.111 306.162 200.525 306.162 200.525"
          fill="#B5C9C9"
        />
        <path
          d="M306.954 209.411C306.954 209.411 292.949 210.953 294.347 206.156C295.745 201.358 307.04 209.344 307.04 209.344"
          fill="#B5C9C9"
        />
        <path
          d="M307.351 218.583C307.351 218.583 293.346 220.125 294.744 215.328C296.142 210.529 307.437 218.515 307.437 218.515"
          fill="#B5C9C9"
        />
        <path
          d="M295.735 174.109C295.735 174.109 289.304 161.572 294.285 161.169C299.266 160.766 295.83 174.165 295.83 174.165"
          fill="#B5C9C9"
        />
        <path
          d="M300.407 181.687C300.407 181.687 296.98 168.021 301.923 168.755C306.866 169.49 300.486 181.764 300.486 181.764"
          fill="#B5C9C9"
        />
        <path
          d="M304.105 191.466C304.105 191.466 304.035 177.377 308.661 179.269C313.286 181.16 304.163 191.559 304.163 191.559"
          fill="#B5C9C9"
        />
        <path
          d="M306.117 200.875C306.117 200.875 308.141 186.931 312.434 189.489C316.727 192.047 306.161 200.975 306.161 200.975"
          fill="#B5C9C9"
        />
        <path
          d="M306.803 209.397C306.803 209.397 313.439 196.968 316.609 200.83C319.779 204.693 306.811 209.506 306.811 209.506"
          fill="#B5C9C9"
        />
        <path
          d="M307.575 218.651C307.575 218.651 314.211 206.222 317.381 210.084C320.552 213.947 307.583 218.76 307.583 218.76"
          fill="#B5C9C9"
        />
        <path
          d="M307.217 225.391C306.999 225.346 306.839 225.149 306.847 224.92C307.712 199.974 302.775 186.118 298.481 178.887C293.848 171.085 288.953 169.124 288.904 169.105C288.665 169.013 288.546 168.745 288.637 168.506C288.729 168.266 289 168.146 289.236 168.238C289.445 168.318 294.424 170.288 299.222 178.318C303.608 185.655 308.651 199.702 307.776 224.953C307.766 225.209 307.552 225.41 307.295 225.4C307.268 225.399 307.242 225.396 307.217 225.391Z"
          fill="#B5C9C9"
        />
      </g>
      <path
        d="M222.843 154.008V160.941C222.843 161.739 223.49 162.386 224.288 162.386H226.893C227.238 162.386 227.533 162.618 227.627 162.95C228.166 164.843 228.968 166.624 229.997 168.252L229.998 168.253L227.812 170.439C227.248 171.003 227.248 171.918 227.812 172.482L232.715 177.385C233.279 177.949 234.194 177.949 234.758 177.385L237.019 175.124L237.022 175.126C238.831 176.209 240.826 177.018 242.943 177.497H242.945V180.586C242.945 181.384 243.592 182.031 244.39 182.031H251.323C252.121 182.031 252.768 181.384 252.768 180.586V177.394H252.77C254.874 176.859 256.848 176.003 258.637 174.879L258.638 174.878L260.822 177.062C261.386 177.626 262.301 177.626 262.865 177.062L267.768 172.159C268.332 171.595 268.332 170.68 267.768 170.116L265.918 168.266C265.673 168.021 265.628 167.65 265.797 167.348C266.639 165.841 267.299 164.22 267.735 162.513C267.823 162.171 268.121 161.928 268.474 161.928H270.97C271.768 161.928 272.415 161.281 272.415 160.483V153.549C272.415 152.751 271.768 152.104 270.97 152.104H268.356C268.01 152.104 267.716 151.872 267.621 151.539C267.139 149.842 266.449 148.236 265.57 146.748C265.39 146.444 265.431 146.063 265.681 145.814L267.444 144.051C268.008 143.487 268.008 142.572 267.444 142.007L262.541 137.104C261.977 136.54 261.062 136.54 260.497 137.104L258.238 139.363C256.59 138.386 254.794 137.624 252.893 137.133C252.551 137.045 252.31 136.747 252.31 136.394V133.902C252.31 133.104 251.663 132.457 250.865 132.457H243.932C243.134 132.457 242.487 133.104 242.487 133.902V136.513C242.487 136.859 242.255 137.153 241.923 137.248C240.226 137.731 238.614 138.425 237.126 139.3C236.822 139.479 236.442 139.437 236.193 139.187L234.433 137.427C233.869 136.863 232.954 136.863 232.39 137.427L227.487 142.33C226.923 142.894 226.923 143.809 227.487 144.374L229.335 146.222C229.58 146.467 229.625 146.838 229.456 147.14C228.613 148.647 227.953 150.27 227.511 151.978C227.423 152.319 227.125 152.561 226.772 152.561H224.284C223.49 152.563 222.843 153.21 222.843 154.008ZM237.679 151.124C238.522 149.527 239.845 148.196 241.436 147.343C252.351 141.489 263.371 152.459 257.56 163.402C256.711 165 255.381 166.331 253.782 167.179C242.877 172.962 231.918 162.039 237.679 151.124Z"
        fill="#E1E8E8"
      />
      <path
        d="M247.63 164.537C251.657 164.537 254.922 161.272 254.922 157.245C254.922 153.218 251.657 149.953 247.63 149.953C243.603 149.953 240.338 153.218 240.338 157.245C240.338 161.272 243.603 164.537 247.63 164.537Z"
        fill="#E1E8E8"
      />
      <path
        d="M107.385 155.427L85.1149 193.999C84.7859 194.568 85.1969 195.279 85.8539 195.279H130.394C131.051 195.279 131.462 194.568 131.133 193.999L108.863 155.427C108.534 154.858 107.713 154.858 107.385 155.427Z"
        fill="#B5C9C9"
      />
      <path
        d="M109.896 188.053C109.896 189.032 109.103 189.825 108.124 189.825C107.145 189.825 106.352 189.032 106.352 188.053C106.352 187.074 107.145 186.281 108.124 186.281C109.102 186.281 109.896 187.074 109.896 188.053Z"
        fill="white"
      />
      <path
        d="M108.124 184.564C107.321 184.564 106.661 183.933 106.624 183.131L106.015 169.829C105.96 168.626 106.92 167.621 108.125 167.621C109.329 167.621 110.29 168.626 110.235 169.829L109.626 183.131C109.587 183.933 108.926 184.564 108.124 184.564Z"
        fill="white"
      />
    </g>
    <path
      d="M259.851 132.948C258.781 134.317 257.185 135.03 255.581 135.03C254.414 135.03 253.239 134.657 252.251 133.888C237.74 122.553 220.928 115.415 202.982 112.871C198.072 112.174 193.065 111.818 188.001 111.818C182.937 111.818 177.938 112.174 173.02 112.871C155.065 115.415 138.261 122.553 123.751 133.888C121.393 135.727 117.99 135.305 116.151 132.948C114.303 130.59 114.725 127.187 117.082 125.348C133.392 112.611 152.318 104.679 172.526 102.006C177.606 101.325 182.775 100.984 188.001 100.984C193.227 100.984 198.388 101.325 203.476 102.006C223.683 104.679 242.618 112.619 258.919 125.348C261.277 127.187 261.69 130.59 259.851 132.948Z"
      fill="#111111"
      stroke="#111111"
      strokeMiterlimit={10}
    />
    <path
      d="M243.942 154.125C242.872 155.478 241.293 156.191 239.689 156.191C238.514 156.191 237.331 155.81 236.343 155.025C226.117 146.955 214.354 141.681 201.762 139.477C197.266 138.683 192.664 138.278 187.997 138.278C183.33 138.278 178.728 138.683 174.231 139.477C161.641 141.681 149.876 146.955 139.651 155.025C137.302 156.872 133.899 156.475 132.043 154.125C130.196 151.784 130.593 148.373 132.943 146.518C144.974 137.022 158.87 130.937 173.737 128.579C178.404 127.826 183.168 127.453 187.997 127.453C192.826 127.453 197.59 127.826 202.257 128.579C217.116 130.937 231.019 137.021 243.051 146.518C245.401 148.373 245.798 151.784 243.942 154.125Z"
      fill="#111111"
      stroke="#111111"
      strokeMiterlimit={10}
    />
    <path
      d="M227.049 176.749C225.17 179.075 221.759 179.431 219.433 177.543C213.705 172.901 207.012 169.603 199.915 167.853C196.034 166.897 192.04 166.403 188.005 166.403C183.971 166.403 179.968 166.897 176.095 167.853C168.998 169.604 162.305 172.901 156.577 177.543C155.573 178.362 154.365 178.75 153.166 178.75C151.594 178.75 150.031 178.07 148.961 176.749C147.073 174.424 147.43 171.013 149.755 169.133C157.137 163.146 165.838 159.006 175.042 156.988C179.279 156.056 183.63 155.578 188.005 155.578C192.38 155.578 196.731 156.056 200.968 156.988C210.173 159.005 218.874 163.146 226.255 169.133C228.572 171.013 228.929 174.424 227.049 176.749Z"
      fill="#111111"
      stroke="#111111"
      strokeMiterlimit={10}
    />
    <path
      d="M187.994 181.359C193.829 181.36 198.559 186.09 198.559 191.925C198.558 197.759 193.829 202.489 187.994 202.489C182.159 202.489 177.429 197.759 177.429 191.925C177.429 186.09 182.159 181.359 187.994 181.359Z"
      fill="#00F200"
      stroke="#ECF4F4"
    />
    <path
      d="M187.997 67.375C195.14 67.3751 200.859 73.2453 200.719 80.3428L200.708 80.6816L196.892 163.981C196.673 168.736 192.756 172.478 187.997 172.479C183.387 172.479 179.566 168.967 179.134 164.425L179.103 163.981L175.286 80.6816C174.955 73.4336 180.742 67.375 187.997 67.375Z"
      fill="url(#paint0_linear_99_676)"
      stroke="#ECF4F4"
    />
    <path
      d="M187.997 67.375C195.14 67.3751 200.859 73.2453 200.719 80.3428L200.708 80.6816L196.892 163.981C196.673 168.736 192.756 172.478 187.997 172.479C183.387 172.479 179.566 168.967 179.134 164.425L179.103 163.981L175.286 80.6816C174.955 73.4336 180.742 67.375 187.997 67.375Z"
      fill="#00F200"
      stroke="#ECF4F4"
    />
    <path
      d="M138.429 50.3127L122.084 78.6238C121.843 79.0408 122.144 79.5627 122.626 79.5627H155.316C155.798 79.5627 156.099 79.0408 155.858 78.6238L139.513 50.3127C139.273 49.8957 138.67 49.8957 138.429 50.3127Z"
      fill="#E3EDED"
    />
    <path
      d="M138.972 75.5629C139.69 75.5629 140.273 74.9805 140.273 74.2619C140.273 73.5434 139.69 72.9609 138.972 72.9609C138.253 72.9609 137.671 73.5434 137.671 74.2619C137.671 74.9805 138.253 75.5629 138.972 75.5629Z"
      fill="white"
    />
    <path
      d="M138.971 71.7016C138.382 71.7016 137.897 71.2386 137.87 70.6496L137.423 60.8866C137.383 60.0036 138.088 59.2656 138.971 59.2656C139.855 59.2656 140.56 60.0036 140.519 60.8866L140.072 70.6496C140.045 71.2376 139.56 71.7016 138.971 71.7016Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_99_676"
        x1={187.997}
        y1={201.301}
        x2={187.997}
        y2={87.5438}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8AD3FF" />
        <stop offset={1} stopColor="#5F9CFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
